import React, { FC, useEffect } from 'react';
import styled from 'styled-components';
import colors from 'const/style/colors';
import fonts from 'const/style/fonts';
import { Link } from 'react-router-dom';
import BG from 'assets/img/bg_footer.svg';
import IconName from 'assets/icon/icon_footer_name.png';
import IconEmail from 'assets/icon/icon_footer_email.png';
import IconCall from 'assets/icon/icon_footer_call.png';
import { inject, observer } from 'mobx-react';
import Login from 'models/Login';

const Frame = styled.div`
  width:100%;
  height:1em;
  display:flex;
  flex-direction:row;
  justify-content: center;
  align-items:center;
  text-align:center;
  padding: 22px;

  ${(props) => ((props as any)['data-mode']===0?
   `
   border-top: 1px solid rgba(255,255,255, .15);
   background: rgba(255,255,255, .06);
   ` : 
   `
   border-bottom:${(props as any)['data-mode']};
   border-top: 1px solid rgba(216, 219, 227, 1);
   background: rgba(246, 248, 252, 1);   
   `
   )};
 
  div {
    display:flex;
    flex-direction:row;
    font :Medium 13px/32px Noto Sans KR;
    color:#AEB1BA;
    h3{
        margin-left:5px;
    }
    button{
      background:transparent;
      color:#AEB1BA;
    }
  }

  .line{
    /* border: 1px solid #AEB1BA88; */
    background: #AEB1BA88;
    height:19px;
    width:1px;
    margin-left:24px;
    margin-right:24px;
  }
  .btn-privacy {
    text-decoration: underline;
    font-weight:bold;
  }

`;

export enum FooterMode{
  TRANSPARENT,
  WHITE,
}

interface IFooter{
  loginInfo?:Login;
  mode?:FooterMode;
}

const Footer:FC<IFooter> = (props:IFooter) => {
 const {loginInfo,mode=FooterMode.TRANSPARENT}=props;

  useEffect(() => {
    loginInfo!.getCompanyInfo();
}, [])


if(loginInfo==undefined) return <Frame className='frame-footer' data-mode={mode}></Frame>
if(loginInfo!.companyInfo==undefined) return <Frame className='frame-footer' data-mode={mode}></Frame>

  return (
    <Frame className='frame-footer'
      data-mode={mode}>
      <div>
          <img src={IconName}/>
          <h3>{loginInfo!.companyInfo!.managerName}</h3>
      </div>
      <div className='line'/>
      <div>
          <img src={IconEmail}/>
          <h3>{loginInfo!.companyInfo!.managerEmail}</h3>
      </div>
      <div className='line'/>
      <div>
          <img src={IconCall}/>
          <h3>{loginInfo!.companyInfo!.managerPhone}</h3>
      </div>
      <div className='line'/>
      <div>
          <button className='btn-privacy' onClick={()=>{
          let w=window.open('/privacyterms','개인정보 수집 및 이용에 관한 동의','width=800,height=574,location=no,status=no,scrollbars=yes');
          w!.onload = function() { 
            w!.document.title = "개인정보 수집 및 이용에 관한 동의"; 
            // w!.document.body.innerHTML=loginInfo.companyInfo!.privacyPolicyContents[0];
          }
        }}>개인정보 처리방침</button>
      </div>
  </Frame>
  )
  };
  export default inject('loginInfo')(observer(Footer));
